import React from 'react';

function Footer () {
  return (
    <footer className="main-footer">
      <div className="pull-right hidden-xs">
        <b>Version</b> 1.0
      </div>
      <strong>Copyright &copy; Reactive Admin All rights reserved.</strong>
    </footer>
  );
}

Footer.displayName = 'Footer';

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js